"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTurnedOn = exports.selectHasDisableDislikesAdditionalFeature = exports.selectHasDisableControlsAdditionalFeature = exports.selectPreloadTracks = exports.selectKioskMode = exports.selectAutoPlay = exports.selectSleepIntervals = exports.selectShouldSleep = exports.selectTheme = exports.selectLastConnected = exports.selectIsPlaybackLocked = exports.selectInterruptedPlaybackLock = exports.selectOfflinePlaybackLock = exports.selectIsConnected = exports.selectBindingCode = exports.selectAutoStart = exports.selectAnalyticsEnabled = void 0;
var _kernel_store_types_1 = require("../types");
var _kernel_container_1 = __importDefault(require("../../container"));
function selectAnalyticsEnabled(state) {
    var _a, _b;
    return (_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.analyticsEnabled) !== null && _b !== void 0 ? _b : true;
}
exports.selectAnalyticsEnabled = selectAnalyticsEnabled;
function selectAutoStart(state) {
    var _a, _b;
    return (_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.autoStart) !== null && _b !== void 0 ? _b : false;
}
exports.selectAutoStart = selectAutoStart;
function selectBindingCode(state) {
    return state.global.bindingCode;
}
exports.selectBindingCode = selectBindingCode;
function selectIsConnected(state) {
    var _a, _b;
    var forcedOffline = _kernel_container_1.default.get("SETTINGS").getSetting("FORCE_OFFLINE_MODE", false);
    if (forcedOffline) {
        return false;
    }
    return (_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.isConnected) !== null && _b !== void 0 ? _b : false;
}
exports.selectIsConnected = selectIsConnected;
function selectOfflinePlaybackLock(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.playbackLock) === null || _b === void 0 ? void 0 : _b.offline) !== null && _c !== void 0 ? _c : false;
}
exports.selectOfflinePlaybackLock = selectOfflinePlaybackLock;
function selectInterruptedPlaybackLock(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.playbackLock) === null || _b === void 0 ? void 0 : _b.interrupted) !== null && _c !== void 0 ? _c : false;
}
exports.selectInterruptedPlaybackLock = selectInterruptedPlaybackLock;
function selectIsPlaybackLocked(state) {
    var _a, _b, _c, _d, _e;
    return (_e = (((_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.playbackLock) === null || _b === void 0 ? void 0 : _b.offline) || ((_d = (_c = state.global) === null || _c === void 0 ? void 0 : _c.playbackLock) === null || _d === void 0 ? void 0 : _d.interrupted))) !== null && _e !== void 0 ? _e : false;
}
exports.selectIsPlaybackLocked = selectIsPlaybackLocked;
function selectLastConnected(state) {
    var _a, _b;
    return (_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.lastConnected) !== null && _b !== void 0 ? _b : 0;
}
exports.selectLastConnected = selectLastConnected;
function selectTheme(state) {
    var _a, _b;
    return (_b = (_a = state.global) === null || _a === void 0 ? void 0 : _a.theme) !== null && _b !== void 0 ? _b : "auto";
}
exports.selectTheme = selectTheme;
function selectShouldSleep(state) {
    var _a;
    return ((_a = state.global) === null || _a === void 0 ? void 0 : _a.shouldSleep) || false;
}
exports.selectShouldSleep = selectShouldSleep;
function selectSleepIntervals(state) {
    return {
        start: state.global.startSleep,
        end: state.global.endSleep,
    };
}
exports.selectSleepIntervals = selectSleepIntervals;
function selectAutoPlay(state) {
    var _a;
    return ((_a = state.global) === null || _a === void 0 ? void 0 : _a.autoPlay) || false;
}
exports.selectAutoPlay = selectAutoPlay;
function selectKioskMode(state) {
    var _a;
    return ((_a = state.global) === null || _a === void 0 ? void 0 : _a.kioskMode) || false;
}
exports.selectKioskMode = selectKioskMode;
function selectPreloadTracks(state) {
    var _a;
    return ((_a = state.global) === null || _a === void 0 ? void 0 : _a.preloadTracks) || false;
}
exports.selectPreloadTracks = selectPreloadTracks;
function selectHasDisableControlsAdditionalFeature(state) {
    var _a;
    return (((_a = state.global) === null || _a === void 0 ? void 0 : _a.additionalFeatures) || []).includes(_kernel_store_types_1.EAdditionalFeatureType.DISABLE_CONTROLS);
}
exports.selectHasDisableControlsAdditionalFeature = selectHasDisableControlsAdditionalFeature;
function selectHasDisableDislikesAdditionalFeature(state) {
    var _a;
    return (((_a = state.global) === null || _a === void 0 ? void 0 : _a.additionalFeatures) || []).includes(_kernel_store_types_1.EAdditionalFeatureType.DISABLE_DISLIKES);
}
exports.selectHasDisableDislikesAdditionalFeature = selectHasDisableDislikesAdditionalFeature;
function selectTurnedOn(state) {
    return state.global.turnedOn;
}
exports.selectTurnedOn = selectTurnedOn;
//# sourceMappingURL=global.js.map